<nb-card>
    <nb-card-header>
        lessons
    </nb-card-header>

    <nb-card-body>
        <ng2-smart-table (editConfirm)="onEditLesson($event)" (deleteConfirm)="onDeleteLesson($event)" (createConfirm)="onCreateLesson($event)" [settings]="settings" [source]="source">
        </ng2-smart-table>
    </nb-card-body>
</nb-card>